import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { defineComponent, ref, toRef, watch } from "vue";
import { usePopperjs } from "./usePopper";
library.add(faTimesCircle);
export default defineComponent({
    components: { FontAwesomeIcon },
    props: {
        // hook options
        delayOnMouseout: Number,
        delayOnMouseover: Number,
        trigger: String,
        forceShow: Boolean,
        modifiers: Array,
        onFirstUpdate: Function,
        placement: String,
        strategy: String,
        // component props
        popperIs: {
            default: "div",
            type: String,
        },
        popperProps: {
            type: Object,
        },
        referenceIs: {
            default: "span",
            type: String,
        },
        referenceProps: {
            type: Object,
        },
        arrow: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            default: "dark",
        },
        title: {
            type: String,
            default: null,
        },
    },
    emits: [
        "show",
        "hide",
        "before-enter",
        "enter",
        "after-enter",
        "enter-cancelled",
        "before-leave",
        "leave",
        "after-leave",
        "leave-cancelled",
    ],
    setup(props, { emit }) {
        const reference = ref();
        const popper = ref();
        const { visible } = usePopperjs(reference, popper, {
            ...props,
            trigger: toRef(props, "trigger"),
            forceShow: toRef(props, "forceShow"),
            disabled: toRef(props, "disabled"),
            delayOnMouseover: toRef(props, "delayOnMouseover"),
            delayOnMouseout: toRef(props, "delayOnMouseout"),
            onShow: () => emit("show"),
            onHide: () => emit("hide"),
        });
        watch(() => [visible.value, props.disabled], () => {
            if (props.disabled && visible.value) {
                visible.value = false;
            }
        }, { flush: "sync" });
        const handle = (event) => (...args) => {
            return emit(event, ...args);
        };
        return {
            visible,
            reference,
            popper,
            handle,
        };
    },
});
